import { Component, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';

import { LandingText } from '../landing.types';
import { RevealOnScrollDirective } from './reveal-on-scroll.directive';

@Component({
    selector: 'app-landing-hero',
    standalone: true,
    imports: [RouterModule, ButtonModule, RippleModule, RevealOnScrollDirective],
    templateUrl: './landing-hero.component.html',
    styleUrl: './landing-hero.component.scss'
})
export class LandingHero {
    readonly text = input.required<LandingText>();
    readonly scrollTo = output<string>();
}
